import React, { useState } from 'react';
import Select from "react-select";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import cn from "classnames";
import { isValidEmail } from '../../../../../helpers/validators';

import './EventGuestlist.sass';

const MySwal = withReactContent(Swal);

export const EditGuestInfoModal = ({
  guestData,
  event,
  handleChangeField,
  saveGuestInfo,
  editedGuestIdx,
  closeModalHandler,
}) => {
  const ticketTemplateList = event.ticketTemplates.map(tt => ({
    value: tt.id,
    label: tt.id + ' - ' + tt.ticketName,
  }));

  const [isSaveBtnClick, setSaveBtnClick] = useState(false);

  const changeInputData = (name, value) => {
    handleChangeField(name, value);
    setSaveBtnClick(false);
  };

  const handleSaveData = () => {
    const { email, ticketTemplateId } = guestData;

    if (!isValidEmail(email) || !ticketTemplateId) {
      setSaveBtnClick(true);

      return;
    };

    saveGuestInfo(editedGuestIdx);
    MySwal.close();
  };

  return (
    <div>
      <div className="edit-user-modal__fields">
        <div className="add-event__block">
          <label>Full name</label>
          <input
            type="text"
            name="name"
            value={guestData.name}
            placeholder="Enter full name"
            minLength="3"
            maxLength="500"
            onChange={({target}) => changeInputData(target.name, target.value)}
          />
        </div>
        <div className="add-event__block">
          <label>Email (required)</label>
          <input
            type="text"
            name="email"
            value={guestData.email}
            placeholder="Enter email"
            minLength="3"
            maxLength="500"
            onChange={({target}) => changeInputData(target.name, target.value)}
            className={!isValidEmail(guestData.email) && isSaveBtnClick ? "add-event__error": ""}
          />
          {!isValidEmail(guestData.email)&& isSaveBtnClick && (
            <span className="add-event__message">Field is required</span>
          )}
        </div>
        <div className="add-event__block">
          <label>Ticket template (required)</label>
          <Select
            options={ticketTemplateList}
            name="ticketTemplateId"
            classNamePrefix="custom-select"
            value={ticketTemplateList.find(tt => guestData.ticketTemplateId === tt.value)}
            onChange={(value) => changeInputData('ticketTemplateId', value.value)}
            className={cn("seasonpass__select custom-select", {
              "add-event__error": !guestData.ticketTemplateId && isSaveBtnClick,
            })}
            placeholder="Select ticket template"
            theme={(theme) => ({
              ...theme,
              colors: {
                ...theme.colors,
                primary: "#6071B5",
                primary25: "#F2F4FE",
                primary50: "#F2F4FE",
                primary75: "#F2F4FE",
              },
            })}
          />
          {!guestData.ticketTemplateId && isSaveBtnClick && (
            <span className="add-event__message">Field is required</span>
          )}
        </div>
      </div>

      {event.mapId && (
        <div className="edit-user-modal__seat-info">
          <div className="add-event__block edit-user-modal__search-small">
            <label>Area</label>
            <input
              className="edit-user-modal__search-small"
              type="text"
              name="area"
              value={guestData.area}
              placeholder="Area"
              minLength="3"
              maxLength="500"
              onChange={({target}) => changeInputData(target.name, target.value.toUpperCase())}
            />
          </div>
          <div className="add-event__block edit-user-modal__search-small">
            <label>Side</label>
            <input
              className="edit-user-modal__search-small"
              type="text"
              name="side"
              value={guestData.side}
              placeholder="Side"
              minLength="3"
              maxLength="500"
              onChange={({target}) => changeInputData(target.name, target.value.toUpperCase())}
            />
          </div>
          <div className="add-event__block edit-user-modal__search-small">
            <label>Row</label>
            <input
              className="edit-user-modal__search-small"
              type="text"
              name="row"
              value={guestData.row}
              placeholder="Row"
              minLength="3"
              maxLength="500"
              onChange={({target}) => changeInputData(target.name, target.value.toUpperCase())}
            />
          </div>
          <div className="add-event__block edit-user-modal__search-small">
            <label>Seat</label>
            <input
              className="edit-user-modal__search-small"
              type="text"
              name="seat"
              value={guestData.seat}
              placeholder="Seat"
              minLength="3"
              maxLength="500"
              onChange={({target}) => changeInputData(target.name, target.value.toUpperCase())}
            />
          </div>
        </div>
      )}

      <div className="swal2-actions">
        <button
          className="swal2-cancel swal2-styled"
          onClick={closeModalHandler}
        >
          Cancel
        </button>
        <button
          className="swal2-confirm swal2-styled"
          onClick={handleSaveData}
        >
          Save
        </button>
      </div>
    </div>
  )
}
